module.exports = __webpack_public_path__ + "static/media/trending_hero_laptop.01b48057.png";